<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">{{ isEditMode ? 'Edit Case' : 'Add Case' }}</h4>
            <p class="card-category">Complete case details</p>
          </div>
          <div class="card-body">
            <form [formGroup]="caseForm" (ngSubmit)="submitForm()">
              <div class="row">
                <!-- Case Number -->
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Case Number</mat-label>
                    <input matInput formControlName="caseNumber" placeholder="Enter case number" />
                  </mat-form-field>
                </div>

                <!-- Year -->
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Year</mat-label>
                    <input matInput type="number" formControlName="year" placeholder="Enter year" />
                  </mat-form-field>
                </div>

                <!-- Filing Date -->
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Filing Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="filingDate" placeholder="Choose date" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>

                <!-- Under Section -->
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Under Section</mat-label>
                    <input matInput formControlName="underSection" placeholder="Enter under section" />
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <!-- Status -->
                <div class="col-md-3">
                  <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Status </mat-label>
                    <mat-select formControlName="status" required>
                      <mat-option value="Pending">Pending</mat-option>
                      <mat-option value="Disposed">Disposed</mat-option>
                      <mat-option value="Disposed (Dormant)">Disposed (Dormant)</mat-option>
                    </mat-select>
                    <mat-error *ngIf="caseForm.get('status')?.hasError('required') && caseForm.get('status')?.touched">
                      Status is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Party Role -->
                <div class="col-md-3">
                  <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Party Role </mat-label>
                    <mat-select formControlName="partyRole" required>
                      <mat-option value="Applicant">Applicant</mat-option>
                      <mat-option value="Defendant">Defendant</mat-option>
                    </mat-select>
                    <mat-error *ngIf="caseForm.get('partyRole')?.hasError('required') && caseForm.get('partyRole')?.touched">
                      Party Role is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Judge -->
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Judge</mat-label>
                    <input matInput formControlName="judge" placeholder="Enter judge name" />
                  </mat-form-field>
                </div>

                <!-- Opposite Party -->
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Opposite Party</mat-label>
                    <input matInput formControlName="oppositeParty" placeholder="Enter opposite party" />
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <!-- Opposite Party Advocate -->
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Opposite Party Advocate</mat-label>
                    <input matInput formControlName="oppositePartyAdvocate" placeholder="Enter opposite party advocate" />
                  </mat-form-field>
                </div>

                <!-- Opposite Party Role -->
                <div class="col-md-3">
                  <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Opposite Party Role</mat-label>
                    <mat-select formControlName="oppositePartyRole" required>
                      <mat-option value="Applicant">Applicant</mat-option>
                      <mat-option value="Defendant">Defendant</mat-option>
                    </mat-select>
                    <mat-error *ngIf="caseForm.get('oppositePartyRole')?.hasError('required') && caseForm.get('oppositePartyRole')?.touched">
                      Opposite Party Role is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Transferred At -->
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Transferred At</mat-label>
                    <input matInput [matDatepicker]="transferredPicker" formControlName="transferredAt" placeholder="Choose date" />
                    <mat-datepicker-toggle matSuffix [for]="transferredPicker"></mat-datepicker-toggle>
                    <mat-datepicker #transferredPicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <!-- Disposed At -->
                <div class="col-md-3">
                  <mat-form-field class="w-100">
                    <mat-label>Disposed At</mat-label>
                    <input matInput [matDatepicker]="disposedPicker" formControlName="disposedAt" placeholder="Choose date" />
                    <mat-datepicker-toggle matSuffix [for]="disposedPicker"></mat-datepicker-toggle>
                    <mat-datepicker #disposedPicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <!-- District -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>District</mat-label>
                    <mat-select formControlName="districtId">
                      <mat-option *ngFor="let district of districts" [value]="district.id">
                        {{ district.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Court Type -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Court Type</mat-label>
                    <mat-select formControlName="courtTypeId">
                      <mat-option *ngFor="let courtType of courtTypes" [value]="courtType.id">
                        {{ courtType.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Case Type -->
                <div class="col-md-4">
                  <mat-form-field class="w-100">
                    <mat-label>Case Type</mat-label>
                    <mat-select formControlName="caseTypeId">
                      <mat-option *ngFor="let caseType of caseTypes" [value]="caseType.id">
                        {{ caseType.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <!-- Client -->
                <div class="col-md-12">
                  <mat-form-field class="w-100">
                    <mat-label>Client</mat-label>
                    <mat-select formControlName="clientId" required>
                      <mat-option *ngFor="let client of clients" [value]="client.id">
                        {{ client.fullName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <app-file-uploader [folder]="'case'"></app-file-uploader>
                </div>
              </div>
              <button mat-raised-button color="danger" type="submit" class="btn btn-danger pull-right" [disabled]="isSubmited" (click)="isSubmited = true">
                {{ isEditMode ? 'Update Case' : 'Add Case' }}
              </button>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
